import React from 'react'
import rain from '../media/rainsound.mp3'
export default class CheckBoxControl extends React.Component{
    divStyle = {
        backgroundColor: this.props.color,
        display:"inline-block",
        margin: "0 5px 0 0",
        color: "white"
    }

    constructor(props){
        super(props)
        this.state = {
            playing: false,
            checked: false
        }
    }
    
    handleClick = ()=>{
        this.setState({playing: !this.state.playing, checked: !this.state.checked})
        // this.player.src = "../media/rainsound.mp3";
        // this.player.play();
    }
    componentDidUpdate(){
        if(this.state.playing){
            let currentSound;
            switch(this.props.sound){
                case "rain":
                    currentSound = rain;
                    break;
                default:
                    // console.log("no sound")
            }

            if(currentSound){
                this.player.src = currentSound;
                this.player.play()  
            }
        }
        if(!this.state.playing){
            this.player.pause();
        }
    }

    componentDidMount(){
        document.addEventListener('keydown',this.keydownHandler);
      }
    
      componentWillUnmount(){
        document.removeEventListener('keydown',this.keydownHandler);
      }

    keydownHandler = (e)=>{
        switch(e.keyCode){
            case 81: //1
                this.setState({playing: !this.state.playing, checked: !this.state.checked})
                break;
            default:
                // console.log("unknown key")
            }
      }
    
    render(){
        return(
        <div style={this.divStyle} className="checkBoxContainer">
            <label title="play rain sound" alt="rain sound">
                <input readOnly={true} type="checkbox" id="checkbox" checked={this.state.checked} onClick={this.handleClick}/>
                {this.props.name}
            </label>
            <audio loop ref={ref => this.player = ref}/>
            
        </div>
        )
    }
}